import React from "react";
import { SvgIcon } from "@mui/material";

function AllocatedIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        width={50}
        height={50}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          x="5"
          y="5"
          width="40"
          height="40"
          rx="20"
          ry="20"
          fill="#4A4A4A"
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="15"
          fill="white"
        >
          AH
        </text>
      </svg>
    </SvgIcon>
  );
}

export default AllocatedIcon;
